<template id="Page8800">
    <div class="vats-price">
        <Loader v-if="loader.data > 0"/>
        <template v-else>
            <VatsSelect
                :items="vatsItems"
                :currentVats="currentVats"
                :vatsSelecTitle="vatsSelectTitle"
                @change="changeVats"
                v-if="!hideSelectVats"
            />
            <h2 class="block-title mt-2 mb-2" v-if="title">{{ title }}</h2>
            <div class="row">
                <div :class="showOnlyNumbers && !readOnly ? 'col-lg-12' : 'col-lg-9'">
                    <div class="numbers">
                        <NumbersFilter
                            ref="filter"
                            :showRegionSelect="showRegionSelect"
                            :regionSelectMultiple="regionSelectMultiple"
                            :showDetailSearch="showDetailSearch"
                            :branches="branches"
                            :counters="counters"
                            v-model:category="category"
                            :isDemoVats="isDemoVats"
                            :motivationPopoverContent="chain !== 'virtual_number' ? motivationPopoverContent : null"
                            @selectBranch="showSelectBranchModal"
                            @applyFilter="applyFilter"
                        />
                        <div class="numbers-type_main" data-element="numbers-container">
                            <Loader v-if="reloading" />
                            <template v-else>
                                <template v-if="!isEmpty">
                                    <NumbersGroup
                                        :showChoseRandomButton="false"
                                        :isMobile="isMobile"
                                        :group="group"
                                        :branch="branchesGrouped[group.branchId]"
                                        :category="category"
                                        :isDemoVats="isDemoVats"
                                        :canBuyCount="canBuyCount"
                                        :viewMode="viewMode"
                                        :isFMC="isFMC"
                                        :groupingCount="isGrouping ? groupingCount : 0"
                                        :numbersCountBeforeRegLink="numbersCountBeforeRegLink"
                                        :patterns="patterns"
                                        :loading="loader.page[group.id]"
                                        :blockLoading="loader.blocks"
                                        :key="group.id"
                                        v-for="(group, i) in displayNumbersGroups"
                                        :hidden="activeNumberGroup.indexOf(i) === -1"
                                        @toggleActive="toggleActive(i)"
                                        @load="load(group)"
                                        @addNumbers="(numbers, params) => addNumbers(numbers, params)"
                                        @removeNumbers="(numbers, params) => removeNumbers(numbers, params)"
                                        @changeProviderTariff="(provider, tariff) => changeProviderTariff(provider, tariff)"
                                    />
                                </template>
                                <template v-if="displayEmptyMessage">
                                    <div class="empty-numbers" data-element="empty-numbers">
                                        <div class="row">
                                            <div class="col-md-3 empty-numbers--icon">
                                                <span class="icon-mobile-phone"></span>
                                            </div>
                                            <div class="col-md-9 empty-numbers--text">
                                                <div v-html="displayEmptyMessage"/>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </div>
                    <template v-if="stepNote && !reloading">
                        <a name="step_note" id="step_note"></a>
                        <div class="step-note fs-sm text-gray" v-html="stepNote"/>
                    </template>
                </div>
                <Aside v-if="!showOnlyNumbers">
                    <template v-slot:miniCart>
                        <MiniCart
                            ref="cart"
                            :cart="cart"
                            :motivationPopoverContent="chain === 'virtual_number' ? motivationPopoverContent : null"
                            :loading="nextStepLoading"
                            @remove="(item) => removeCartItem(item)"
                            @submit="submit"
                        />
                    </template>
                </Aside>
            </div>
        </template>
        <ArcticModal id="number-page__modal">
        </ArcticModal>
    </div>
</template>

<script>

import NumbersPageBlock from '../App.vue';
export default {
    extends: NumbersPageBlock,
    name: 'NumbersPageBlock',
}

</script>